import { render, staticRenderFns } from "./relateDialog.vue?vue&type=template&id=9b2676b4&scoped=true&"
import script from "./relateDialog.vue?vue&type=script&lang=js&"
export * from "./relateDialog.vue?vue&type=script&lang=js&"
import style0 from "./relateDialog.vue?vue&type=style&index=0&id=9b2676b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2676b4",
  null
  
)

export default component.exports